import dayjs from 'dayjs';

export const calculateDateDifference = (startDate: string, endDate: string) => {
  const from = dayjs(startDate);
  const to = dayjs(endDate);
  return to.diff(from, 'day');
};
